import React from 'react';
import styles from './BasicModalLayoutFooter.scss';
import ButtonLoader from '../ButtonLoader';
import { string, func, bool } from 'prop-types';
import classNames from 'classnames';
import { Button } from 'wix-style-react';

export default function BasicModalLayoutFooter({
  okText,
  onOkClick,
  cancelText,
  onCancelClick,
  disabled,
  okLoading,
  displayCancelButton,
  className,
  secondaryText,
  onSecondaryClick,
  displaySecondaryButton,
  form,
  okAutoFocus,
  okSkin,
}) {
  const footerStyles = classNames({
    [styles.wrapper]: true,
    [styles.hasSecondaryButton]: displaySecondaryButton,
    [className]: true,
  });

  return (
    <div className={footerStyles}>
      {displaySecondaryButton && (
        <Button priority="secondary" onClick={onSecondaryClick} dataHook="footer-secondary-button">
          {secondaryText}
        </Button>
      )}
      <div>
        {displayCancelButton && (
          <Button priority="secondary" onClick={onCancelClick} dataHook="footer-cancel-button">
            {cancelText}
          </Button>
        )}
        {displayCancelButton && <span className={styles.gap} />}
        <ButtonLoader
          isLoading={okLoading}
          onClick={onOkClick}
          dataHook="footer-ok-button"
          disabled={disabled}
          type={form ? 'submit' : null}
          autoFocus={okAutoFocus}
          skin={okSkin}
        >
          {okText}
        </ButtonLoader>
      </div>
    </div>
  );
}

BasicModalLayoutFooter.displayName = 'BasicModalLayoutFooter';

BasicModalLayoutFooter.propTypes = {
  okText: string,
  onOkClick: func,
  cancelText: string,
  onCancelClick: func,
  disabled: bool,
  okLoading: bool,
  displayCancelButton: bool,
  displaySecondaryButton: bool,
  secondaryText: string,
  onSecondaryClick: func,
  form: bool,
  okAutoFocus: bool,
  okSkin: string,
};

BasicModalLayoutFooter.defaultProps = {
  okText: 'OK',
  onOkClick: () => null,
  cancelText: 'Cancel',
  onCancelClick: () => null,
  displayCancelButton: true,
  okSkin: 'standard',
};
